import safeParse from "../utils/safe_json_parse";
import { getUITranslation } from "../utils/get_ui_translation";

export const saveAsTemplateModal = ({ updateTemplate, createTemplate }) => {
  let templates = safeParse(window.templates).map((t) => {
    t.name = t.name.replace(/\t/g, "  ");
    return t;
  });
  templates = templates.map((template) => {
    template.name = decodeHtmlEntities(template.name);
    return template;
  });
  if (!window._current_academy_premium) {
    if (templates.length == 0) {
      createTemplate({ name: getUITranslation("Modèle personnalisé") });
    } else {
      updateTemplate(templates[0].id);
    }
    return;
  }
  const elem = document.createElement("div");
  elem.className = "js-pick-form-template form_form__slide-modal";
  elem.innerHTML = `
      <div class="content has-p-03">
        <div>
          <div class="js-existing-templates"></div>
          <div>
            <p class="title-2">${getUITranslation("Créer un nouveau modèle")}</p>
            <label>
              <span class="label label--sm">${getUITranslation("Nom du modèle")}</span>
              <div class="text-input text-input--md">
                <input class="text-input__input " type="text" required="">
              </div>
            </label>
            <div class="button-group button-group--horizontal">
              <button class="button button--ghost button--md js-cancel"> ${getUITranslation("Annuler")}</button>
              <button class="button button--primary button--md js-new">${getUITranslation("Créer")}</button>
            </div>
          </div>
        </div>
      </div>
    `;

  if (templates.length > 0) {
    elem.querySelector(".js-existing-templates").append(...buildExistingTemplatesSection(templates));
  }
  document.body.append(elem);

  const onSelectDefautForm = ({ target }) => {
    const id = target.dataset.templateId;
    updateTemplate(id);
    onHideDefaultFormPicker();
  };

  const onNewDefautForm = () => {
    const name = document.querySelector(".js-pick-form-template input").value;
    if (name.length > 0) {
      createTemplate({ name: name });
      onHideDefaultFormPicker();
    }
  };

  document.querySelector(".js-cancel").addEventListener("click", onHideDefaultFormPicker);
  document.querySelectorAll(".js-select").forEach((t) => t.addEventListener("click", onSelectDefautForm));
  document.querySelector(".js-new").addEventListener("click", onNewDefautForm);
};

//------------------------------------------------------------------------------
// Private
//------------------------------------------------------------------------------

const onHideDefaultFormPicker = () => {
  document.querySelector(".js-pick-form-template")?.remove();
};

const decodeHtmlEntities = (text) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};

const buildExistingTemplatesSection = (templates) => {
  const title = document.createElement("p");
  title.className = "title-2";
  title.textContent = getUITranslation("Remplacer un modèle");

  const list = document.createElement("ul");
  templates.forEach((template) => {
    const button = document.createElement("button");
    button.className = "js-select button button--ghost button--md has-text-start";
    button.dataset.templateId = template.id;
    button.textContent = template.name;

    const item = document.createElement("li");
    item.appendChild(button);
    list.appendChild(item);
  });

  return [title, list];
};
